export function trackEvent(
  name: string,
  metadata?: Record<string, unknown>
): void {
  if (typeof window !== "undefined" && window.pendo?.track) {
    window.pendo.track(name, metadata ?? {});
  }
}
